// extracted by mini-css-extract-plugin
module.exports = {"paypalButton":"paypal-button_paypalButton__qY6Pt","paypalIcon":"paypal-button_paypalIcon__Ni2Ne"};